import React from 'react';
import s3 from 'shared/constants/s3';
import { Row, Col, Button } from 'bootstrap';
import MessageConstants from 'shared/constants/Messages';
import { teleprompter } from 'shared/constants/Onboarding';

export default React.createClass({
  displayName: 'TeleprompterWelcome',

  render() {
    return (
      <div className="tele-welcome">
        <Row>
          <Col md={24}>
            <div className="tele-welcome-img">
              <img src={s3.upgradeTeleprompter} alt="" />
            </div>
          </Col>
          <Col md={24} className="tele-welcome-title">
            {teleprompter.teleprompterWelcomeTitle}
          </Col>
          <Col md={24} className="tele-welcome-desc">
            <p>{MessageConstants.welcomeTeleprompter}</p>
          </Col>
          <Col md={24} className="tele-welcome-subtitle">
            <h4>Please enjoy a free trial of this premium feature.</h4>
          </Col>
          <Col md={24} className="tele-welcome-button">
            <Button onClick={this.props.onHide}>Get Started</Button>
          </Col>
          <Col md={24} className="tele-welcome-learn">
            <p>
              <a
                href="https://shoflo.tv/teleprompter-software/"
                target="_blank"
              >
                Learn more about Prompter View
              </a>
              .
            </p>
          </Col>
        </Row>
      </div>
    );
  },
});
